var validationMessages = {
  en: {
    nameRequired: 'Please enter your name.',
    emailRequired: 'Please enter your email address.',
    emailInvalid: 'Please enter a valid email address.',
    messageRequired: 'Please enter your message.'
  },
  ja: {
    nameRequired: 'お名前を入力してください。',
    emailRequired: 'メールアドレスを入力してください。',
    emailInvalid: '正しいメールアドレスを入力してください。',
    messageRequired: 'お問い合わせ内容を入力してください。'
  }
};

export function validateContactForm(form, language) {
  var messages = validationMessages[language] || validationMessages.en;
  var errors = {};

  if (!form.name || !form.name.trim()) {
    errors.name = messages.nameRequired;
  }

  if (!form.email || !form.email.trim()) {
    errors.email = messages.emailRequired;
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) {
    errors.email = messages.emailInvalid;
  }

  if (!form.message || !form.message.trim()) {
    errors.message = messages.messageRequired;
  }

  return errors;
}
